"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIE11 = exports.windowIsAboveWidth = void 0;

exports.windowIsAboveWidth = function (width) {
  return window.innerWidth >= parseInt(width);
};

exports.isIE11 = function () {
  return typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.indexOf('Trident/') !== -1;
};